import { connect } from 'react-redux';

// Selectors:
import { getIsHotelOnly, getIsMobile } from 'src/store/view/selectors';
import {
  isAwaitingFiltration,
  isShownLoadingSelector,
} from '../../searchStatus/selectors';
import { getBrowser } from '../../selectors/browser';
import { getIsWhitelabel } from '../../selectors/view';
import {
  hotelsListSelector,
  hotelsVisibleLimitSelector,
} from '../../store/hotels/selectors';
import { isMapViewSelector } from '../../store/map/selectors';

import {
  isEmptyFiltrationSelector,
  penalizedHotelsVisibleLimitSelector,
} from '../../store/emptyFiltration/selectors';
import Hotels from './Hotels';

type Props = {
  mobileHotelFilter?: boolean;
  cancelSkeletons?: boolean;
};

const mapStateToProps = (state, props: Props) => {
  const { mobileHotelFilter, cancelSkeletons } = props;
  return {
    mobileHotelFilter,
    isEmptyFiltration: isEmptyFiltrationSelector(state),
    hotels: hotelsListSelector(state),
    visibleLimit: hotelsVisibleLimitSelector(state),
    penalizedHotelsVisibleLimit: penalizedHotelsVisibleLimitSelector(state),
    fullMapView: isMapViewSelector(state),
    awaitFiltration: isAwaitingFiltration(state),
    browser: getBrowser(state),
    isWhitelabel: getIsWhitelabel(state),
    isMobile: getIsMobile(state),
    isHotelOnly: getIsHotelOnly(state),
    isShownLoading: !cancelSkeletons && isShownLoadingSelector(state),
  };
};

export default connect(mapStateToProps)(Hotels);
